// extracted by mini-css-extract-plugin
export default {"modeToggle":"DashboardModeToggle_modeToggle__RRVjJ","label":"DashboardModeToggle_label__Do5KH"};